// extracted by mini-css-extract-plugin
module.exports = {"container":"Profile_container__3-CY0","avatar":"Profile_avatar__2bKcJ","popup":"Profile_popup__2kDCs","item":"Profile_item__31djP"};